<template>
    <ConfirmationModal
        title="Change primary contact email?"
        yes="Change Email"
        no="Cancel"
        no-color="neutral"
        additional-class-name="PrimaryContactChangeModal"
        v-bind="$attrs"
    >
        <p class="PrimaryContactChangeModal__paragraph" data-test-id="PrimaryContactChangeModal__losingAccess">
            {{ previousEmail }} will lose access to this profile.
        </p>
        <p class="PrimaryContactChangeModal__paragraph" data-test-id="PrimaryContactChangeModal__gainingAccess">
            {{ newEmail }} will be emailed instructions for setting up access.
        </p>
        <p class="PrimaryContactChangeModal__paragraph">
            Requirements, submissions, producers and history are not affected.
        </p>
    </ConfirmationModal>
</template>

<style lang="scss">
    .PrimaryContactChangeModal {
        &__paragraph {
            margin: 0 0 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import ConfirmationModal from '@/components/confirmation-modal/ConfirmationModal.vue';

    /**
     * Confirms a save that hands an entity's profile to a different primary contact.
     *
     * Both addresses are named rather than described, because a mistyped one is the failure this
     * prompt exists to catch and it is only recognisable on sight.
     */
    export default defineComponent({
        name: 'PrimaryContactChangeModal',
        components: {
            ConfirmationModal,
        },
        props: {
            previousEmail: {
                type: String,
                required: true,
            },
            newEmail: {
                type: String,
                required: true,
            },
        },
    });
</script>
